import React from 'react';
import styled from 'styled-components';

// Modern: Sleek glassmorphism cards in a 2-column grid with gradient accents
const ModernTheme = ({ colorTheme }: { colorTheme: string }) => {
   return (
      <Wrapper>
         <Label>Select your plan</Label>
         <Grid>
            <Card $color={colorTheme} $selected>
               <CardTop $color={colorTheme}>
                  <Duration>3 Hrs</Duration>
                  <Price>₱50</Price>
               </CardTop>
               <CardTitle>Unlimited</CardTitle>
               <CardSub>Fast browsing</CardSub>
               <SelectBtn $color={colorTheme} $selected>Selected</SelectBtn>
            </Card>
            <Card $color={colorTheme}>
               <CardTop $color={colorTheme}>
                  <Duration>1 Day</Duration>
                  <Price>₱80</Price>
               </CardTop>
               <CardTitle>Unlimited</CardTitle>
               <CardSub>24hr access</CardSub>
               <SelectBtn $color={colorTheme}>Choose</SelectBtn>
            </Card>
         </Grid>
         <Btn $color={colorTheme}>Continue</Btn>
      </Wrapper>
   );
};

const Wrapper = styled.div``;
const Label = styled.p`font-size: 9px; color: #94a3b8; font-weight: 500; margin-bottom: 8px;`;
const Grid = styled.div`display: grid; grid-template-columns: 1fr 1fr; gap: 6px; margin-bottom: 8px;`;
const Card = styled.div<{ $color: string; $selected?: boolean }>`
   border: 1.5px solid ${({ $selected, $color }) => $selected ? $color : '#e2e8f0'};
   border-radius: 8px;
   padding: 8px 6px 6px;
   background: ${({ $selected }) => $selected ? '#f8fafc' : 'white'};
   text-align: center;
`;
const CardTop = styled.div<{ $color: string }>`
   display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px;
`;
const Duration = styled.span`font-size: 8px; font-weight: 700; color: #475569;`;
const Price = styled.span`font-size: 11px; font-weight: 800; color: #0f172a;`;
const CardTitle = styled.p`font-size: 9px; font-weight: 600; color: #0f172a;`;
const CardSub = styled.p`font-size: 7px; color: #94a3b8; margin-bottom: 5px;`;
const SelectBtn = styled.div<{ $color: string; $selected?: boolean }>`
   font-size: 7px; font-weight: 600; padding: 2px 0; border-radius: 4px; text-align: center;
   background: ${({ $selected, $color }) => $selected ? $color : 'transparent'};
   color: ${({ $selected, $color }) => $selected ? 'white' : $color};
   border: 1px solid ${({ $color }) => $color};
`;
const Btn = styled.div<{ $color: string }>`
   background: ${({ $color }) => $color}; color: white; text-align: center;
   font-size: 9px; font-weight: 600; padding: 5px; border-radius: 6px;
`;

export default ModernTheme;
